import { CommonModule } from '@angular/common';
import { Component, contentChild, inject, input, output } from '@angular/core';
import { FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { menuItems } from '@softline/application';
import { UiCoreModule } from '@softline/ui-core';
import { PageHeaderComponent } from '../page/page-header/page-header.component';
import { PageComponent } from '../page/page.component';
import { QueryPageShortcutsComponent } from './query-page-shortcuts/query-page-shortcuts.component';
import { QueryShortcut } from './query-shortcut';

@Component({
  selector: 'soft-query-page',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PageComponent,
    PageHeaderComponent,
    UiCoreModule,
    QueryPageShortcutsComponent,
  ],
  templateUrl: './query-page.component.html',
  styleUrl: './query-page.component.css',
})
export class QueryPageComponent<T extends object> {
  formRef = inject(FormGroupDirective);

  header = contentChild(PageHeaderComponent, { descendants: true });
  shortcuts = input<QueryShortcut<T>[]>([]);

  constructor() {
    menuItems(() => {
      return [
        {
          type: 'execute',
          name: 'QueryPageComponentQueryCommand',
          outlet: 'responsive',
          class: 'soft-button accent md:m-0 m-4 mt-0',
          icon: 'fa-regular fa-magnifying-glass',
          title: '#SOFTAPPS_CORE.MENU_ITEMS.QUERY',
          canExecute: true,
          execute: () => {
            this.formRef.onSubmit(this.formRef.form.value);
            if (this.formRef.form.valid) this.query.emit(this.formRef.form.value);
          },
        },
      ];
    });
  }

  query = output<T>();

  onShortcutClick(query: T): void {
    this.formRef.form.patchValue(query);
    this.formRef.onSubmit(this.formRef.form.value);
    if (this.formRef.form.valid) this.query.emit(this.formRef.form.value);
  }
}
